import clearImagePath from '../clearImagePath'

const getStrapiMediaData = (media, appendImagePrefix = false) => {
	const attributes = media?.data?.attributes

	return {
		alt: attributes?.alternativeText,
		url: clearImagePath(
			attributes?.url,
			appendImagePrefix ? 'https://pyt-images.imgix.net' : '',
		),
		rawData: {
			...attributes,
		},
	}
}

export default getStrapiMediaData
